import React from 'react'
import moment from 'moment'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// components
import MaxAgeEligibility from 'components/shared/MaxAgeEligibility'

const MaxAgeWarning = props => {
  const { birthdate, season } = props
  const { oldCamperCutoff } = season
  const isOldCamper = moment(birthdate) <= moment(oldCamperCutoff)

  if (!isOldCamper) {
    return null
  }

  return (
    <Box mt={2}>
      <MaxAgeEligibility>
        <Typography paragraph fontWeight='fontWeightBold'>
          Age Eligibility
        </Typography>
      </MaxAgeEligibility>
    </Box>
  )
}

export default MaxAgeWarning
